import React from 'react';
import BannerSectionStyle5 from '../Section/BannerSection/BannerSectionStyle5';
import ContactForm from '../ContactForm';
import Section from '../Section';
import ContactInfoSection from '../Section/ContactInfoSection';
import { pageTitle } from '../../helpers/PageTitle';
import { Helmet } from 'react-helmet';

export default function Contact() {
  pageTitle('Contact');
  return (
    <>
      <Helmet>
        <title>Contact Mercury Healthcare – Get in Touch for Medical Equipment Solutions

        </title>


        <meta name="description" content="Reach out to Mercury Healthcare for inquiries on advanced medical equipment. Get expert support and solutions for your healthcare needs today." />
        {/* Google Tag (gtag.js) */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-MGF4V7P4YB"></script>
        <script>
          {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-MGF4V7P4YB');
      `}
        </script>

      </Helmet>
      <BannerSectionStyle5
        bgUrl="/images/contact/banner_bg.svg"
        imgUrl="/images/contact/contact page size - 881 by 579.png"
        title="Contact Us"
        subTitle="Get in touch with Mercury Healthcare for inquiries,  support, or more information about our advanced  medical equipment. Our team is here to assist you."
      />
      <div className="container cs_mt_minus_110">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <ContactForm />
          </div>
        </div>
      </div>
      <Section
        topMd={200}
        topLg={150}
        topXl={100}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <ContactInfoSection sectionTitle="Find Us Here" />
      </Section>
    </>
  );
}
